module.exports = __webpack_public_path__ + "img/zal.e4ffbb39.png";